const labels = [
  {
    name: 'S.No',
    value: 'index',
  },
  {
    name: 'Refrence ID',
    value: 'id',
  },
  {
    name: 'Name',
    value: 'companyName',
  },
  {
    name: 'Company Type',
    value: 'companyType',
  },
  {
    name: 'Website',
    value: 'website',
  },
  {
    name: 'Company Description',
    value: 'companyDescription',
  },
  {
    name: 'Location',
    value: 'location',
  },
  {
    name: 'Partnership',
    value: 'partnership',
  },
  {
    name: 'Jobs',
    value: 'jobs',
  },
  {
    name: 'Contact',
    value: 'contacts',
  },
  {
    name: 'Remarks',
    value: 'remarks',
  },
];

const csvConverter = (JSONData, fileName = 'Registrations') => {
  const arrData = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;

  let csv = '';
  let row = '';
  let jobLength = 0;
  let contactLen = 0;
  labels.forEach((fieldName) => {
    if (fieldName.name === 'Contact') {
      row += `${fieldName.name},`;
      for (let i = 0; i < arrData.length; i += 1) {
        const arrRow = arrData[i].contacts.length;

        if (contactLen < arrRow) {
          contactLen = arrRow;
        }
      }
      for (let i = 1; i <= ((contactLen * 4) - 1); i += 1) {
        row += ',';
      }
    } else if (fieldName.name === 'Jobs') {
      row += `${fieldName.name},`;

      for (let i = 0; i < arrData.length; i += 1) {
        if (typeof arrData[i].jobs !== 'undefined') {
          const arrRow = arrData[i].jobs.length;

          if (jobLength < arrRow) {
            jobLength = arrRow;
          }
        }
      }
      for (let i = 1; i <= ((jobLength * 3) - 1); i += 1) {
        row += ',';
      }
    } else if (fieldName.name === 'Remarks') {
      row += `${fieldName.name},`;
      for (let i = 1; i <= ((contactLen * 4) - 1); i += 1) {
        row += ',';
      }
    } else {
      row += `${fieldName.name},`;
    }
  });
  row = row.slice(0, -1);
  csv += `${row}\r\n`;

  for (let i = 0; i < arrData.length; i += 1) {
    row = '';
    const arrRow = arrData[i];
    // eslint-disable-next-line
    labels.forEach((fieldName) => {
      const { value } = fieldName;
      if (value === 'index') {
        row += `${i + 1},`;
      } else if (value === 'contacts') {
        // console.log(arrRow[value]);
        arrRow[value].forEach((contact) => {
          let pointer = 0;
          if (typeof arrRow.jobs !== 'undefined') {
            if (arrRow.jobs.length !== jobLength) {
              while (pointer <= jobLength) {
                row += ',';
                pointer += 1;
              }
            }
          } else {
            pointer = 0;

            while (pointer < jobLength * 3) {
              row += ',';
              pointer += 1;
              // console.log(pointer);
            }
          }
          row += `${contact.name}, ${contact.designation}, ${contact.contact}, ${contact.email},`;
          // row += `${contact.designation}`;
          // console.log(row);
          // row += `${contact.contact}`;
          // row += `${contact.email}`;
        });
      } else if (value === 'jobs') {
        // console.log(arrRow[value]);
        if (typeof arrRow[value] !== 'undefined') {
          arrRow[value].forEach((job) => {
            row += `${job.jobTitle}, ${job.ctc}, ${job.employmentType},`;
            // row += `${contact.designation}`;
            // console.log(row);
            // row += `${contact.contact}`;
            // row += `${contact.email}`;
          });
        }
      } else if (value === 'remarks') {
        let pointer = 0;
        if (arrRow.contacts.length !== contactLen) {
          if (typeof arrRow.contacts.length !== 'undefined') {
            while (pointer <= ((contactLen - arrRow.contacts.length) * 4) - 1) {
              row += ',';
              pointer += 1;
            }
          }
        }

        const arrValue = typeof arrRow[value] === 'undefined' ? '' : `"${arrRow[value]}"`;
        row += `${arrValue},`;
      } else {
        const arrValue = typeof arrRow[value] === 'undefined' ? '' : `"${arrRow[value]}"`;
        row += `${arrValue},`;
      }
    });
    row.slice(0, row.length - 1);
    csv += `${row}\r\n`;
  }

  if (csv === '') {
    return;
  }

  const uri = `data:application/csv;charset=utf-8,${escape(csv)}`;
  const link = document.createElement('a');
  link.href = uri;
  link.style = 'visibility:hidden';
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default csvConverter;




// WEBPACK FOOTER //
// ./src/utils/CorporateCSV.js